import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetWorkflowRuleDefinitionsQueryVariables = GraphQLTypes.Exact<{
  filter?: GraphQLTypes.InputMaybe<GraphQLTypes.WorkflowRulesDefinitionFilterInput>;
}>;

export type GetWorkflowRuleDefinitionsQueryResult = { __typename?: 'Query' } & {
  workflowRuleDefinitions: Array<
    GraphQLTypes.Maybe<
      { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
        GraphQLTypes.WorkflowRuleDefinitionType,
        'id' | 'ruleDefinitionTag' | 'ruleDescription' | 'ruleName'
      > & {
          ruleInputFields: Array<
            { __typename?: 'WorkflowRuleFieldType' } & Pick<
              GraphQLTypes.WorkflowRuleFieldType,
              'component' | 'hidden' | 'label' | 'name' | 'required'
            >
          >;
          ruleOutputFields: Array<
            { __typename?: 'WorkflowRuleFieldType' } & Pick<
              GraphQLTypes.WorkflowRuleFieldType,
              'component' | 'hidden' | 'label' | 'name' | 'required'
            >
          >;
        }
    >
  >;
};

export const GetWorkflowRuleDefinitionsDocument = gql`
  query getWorkflowRuleDefinitions($filter: WorkflowRulesDefinitionFilterInput) {
    workflowRuleDefinitions(filter: $filter) {
      id
      ruleDefinitionTag
      ruleDescription
      ruleInputFields {
        component
        hidden
        label
        name
        required
      }
      ruleName
      ruleOutputFields {
        component
        hidden
        label
        name
        required
      }
    }
  }
`;
